import Page from '#globalComponents/Page/Page';
import PageHeader from '#globalComponents/PageHeader/PageHeader';

import CompanySearchCard from '../../components/CompanySearchPage/CompanySearchCard';
import RecentCompaniesCard from '../../components/CompanySearchPage/RecentCompaniesCard';

const CompanySearchPage = () => {
	return (
		<Page header={<PageHeader breadcrumbs={['Unternehmensdetails']} />}>
			<div className="grid items-start gap-4 pb-12 lg:grid-cols-3">
				<CompanySearchCard className="lg:col-span-2" />
				<RecentCompaniesCard />
			</div>
		</Page>
	);
};

export default CompanySearchPage;
